import React from "react"
import { HeaderBlock } from '../panels/HeaderBlock';
import { BookPanel } from '../panels/BookPanel';

export function Book() {

    return (
        <>
            <HeaderBlock />
            <BookPanel />
        </>

    )
}